import React from "react";
import {
  RemoveSupplySideBarContent,
  RemoveSupplySideBarContentProps,
} from "src/components/Form/RemoveSupply";

export const SidebarSection = (props: RemoveSupplySideBarContentProps) => (
  <RemoveSupplySideBarContent {...props} />
);
